import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { API } from "./config";
import { LanguageProvider } from "./i18n";
import { loadGA } from "./lib/analytics";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import DeliveriesPage from "./pages/DeliveriesPage";
import PartnerLogin from "./pages/PartnerLogin";
import PartnerDashboard from "./pages/PartnerDashboard";
import PartnersLanding from "./pages/PartnersLanding";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import LegalPage from "./pages/LegalPage";
import PrecheckinPage from "./pages/PrecheckinPage";
import AcceptModelChangePage from "./pages/AcceptModelChangePage";
import OfficeDisplayPage from "./pages/OfficeDisplayPage";
import MaintenancePage from "./pages/MaintenancePage";

function SiteGate({ children }) {
  const location = useLocation();
  const [maintenance, setMaintenance] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/public`)
      .then(({ data }) => {
        setMaintenance(!!data.maintenance_mode);
        if (data.ga_id) {
          window.__GA_ID = data.ga_id;          // lo usa el banner de cookies al aceptar
          loadGA(data.ga_id);                    // carga si ya hay consentimiento previo
        }
      })
      .catch(() => setMaintenance(false))
      .finally(() => setLoaded(true));
  }, [location.pathname]);

  const internal = ["/admin", "/partner", "/precheckin", "/pago", "/aceptar-cambio"].some((p) => location.pathname.startsWith(p));
  if (loaded && maintenance && !internal) return <MaintenancePage />;
  return children;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-topacio-sand">
          <SiteGate>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/entregas" element={<DeliveriesPage />} />
              <Route path="/partner/login" element={<PartnerLogin />} />
              <Route path="/login" element={<PartnerLogin />} />
              <Route path="/partner" element={<PartnerDashboard />} />
              <Route path="/partners" element={<PartnersLanding />} />
              <Route path="/pago/exito" element={<PaymentSuccess />} />
              <Route path="/pago/cancelado" element={<PaymentCancel />} />
              <Route path="/condiciones" element={<LegalPage doc="conditions" />} />
              <Route path="/legal" element={<LegalPage doc="legal" />} />
              <Route path="/privacidad" element={<LegalPage doc="privacy" />} />
              <Route path="/cookies" element={<LegalPage doc="cookies" />} />
              <Route path="/colaboradores" element={<PartnersLanding />} />
              <Route path="/precheckin/:token" element={<PrecheckinPage />} />
              <Route path="/aceptar-cambio/:token" element={<AcceptModelChangePage />} />
              <Route path="/admin/pantalla" element={<OfficeDisplayPage />} />
            </Routes>
          </SiteGate>
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
